import React, { useCallback, useState, useContext, useEffect } from "react";
import styled from "styled-components";
import TextField from "../Common/TextField";
import womanDoctor from "../../SVGs/womanDoctor.svg";
import CustomButton from "../Common/CustomButton";
import Nav from "../Common/Nav";
import toast from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../server/get_api_client";
import RequireLogout from "../../permissions.js/RequireLogout";
import Footer from "../Common/Footer";
import PageLoader from "../Common/PageLoader";

function Otp() {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState("");
  
  const Submit = useCallback(() => {
    setIsLoading(true);
    if (location.state.forgetPassword) {
      getApiClient()
        .validateOTPCurrent(otp)
        .then((res) => {
          if (res) {
            setIsLoading(false);
            navigate("/ForgetPassword", {
              state: {
                source: 0,
                code: otp,
                username: location.state.username,
              },
            });
          }
        })
        .catch((error) => {
          setIsLoading(false);
          if (error.response.status === 403) {
            navigate("/validateusername", {
              state: {
                forgetPassword: true,
                error:
                  "The provided Security code is no longer valid. Please request a new one.",
              },
            });
          } else {
            setErrorMessage("The provided security code is incorrect");
            setOtp("");
          }
        });
    } else {
      getApiClient()
        .validateOtpOld(otp, location.state.username)
        .then((res) => {
          if (res) {
            setIsLoading(false);
            navigate("/SetupProfile", {
              state: { source: 0, code: otp, contactId: res.data.contactid, username: location.state.username },
            });
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
          if (error.response.status === 403) {
            navigate("/login", {
              state: {
                error:
                  "The Provided Security code is no longer valid. Please request a new one.",
              },
            });
          } else {
            setErrorMessage("The provided security code is incorrect");
            setOtp("");
          }
        });
    }
  }, [otp, setErrorMessage, setOtp]);

  const handleResendOtp = useCallback((e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    setOtp("");

    getApiClient()
      .Login(location.state.username, location.state.password)
      .then((res) => {
        setIsLoading(false);
        if (res.data.existingCust) {
          toast.success("A new security code has been sent to your email");
        }
      })
      .catch(
        makeStandardApiErrorHandler((error) => {
          setIsLoading(false);
          toast.error("Failed to resend security code. Please try again.");
        })
      );
  }, [location.state.username, location.state.password]);

  const maskEmail = (email) => {
    const [localPart, domain] = email.split("@");
    const [domainName, domainExt] = domain.split(".");

    const maskedLocal =
      localPart.length > 2
        ? localPart[0] + "*".repeat(localPart.length - 2) + localPart.slice(-1)
        : localPart;

    const maskedDomain =
      domainName.length > 2
        ? domainName[0] +
          "*".repeat(domainName.length - 2) +
          domainName.slice(-1)
        : domainName;

    return `${maskedLocal}@${maskedDomain}.com`;
  };

  useEffect(() => {
    if (otp.length) {
      setErrorMessage("");
    }
  }, [otp]);
  
  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Nav />
      <Container>
        <InnerContainer>


          <LeftContaienr>
            <LeftContaienrBanner>          
               {!location.state.forgetPassword && (
            <>
              <Title>Join our new portal!</Title>
            </>
            
          )}
                    {location.state.forgetPassword && (
            <>
              <Title>Verify Security Code</Title>
            </>
          )}
          </LeftContaienrBanner>
            <LeftContaienrContent>

            {!location.state.forgetPassword && (
              <>
                <Text>
                  Hippocratic Financial has upgraded to a new client portal—delivering a faster, more seamless experience with a modern, intuitive interface.
                </Text>
              </>
            )}
              {!location.state.forgetPassword && (
              <>
            <Text>
              To complete the transition to the new portal, we've sent you a security code to &nbsp;
              <span style={{ fontWeight: "bold" }}>
                {maskEmail(location.state.email)}
              </span>
              . If you can not find it, check your spam folder.
            </Text>
              </>
            )}
              {location.state.forgetPassword && (
              <>
            <Text>
              We've sent you a security code to &nbsp;
              <span style={{ fontWeight: "bold" }}>
                {maskEmail(location.state.email)}
              </span>
              . If you can not find it, check your spam folder.
            </Text>
              </>
            )}
            <FieldsContainer>
              <TextField
                title={"Verify security code:"}
                direction={"column"}
                type={"number"}
                value={otp}
                setValue={setOtp}
              />
              {errorMessage && <Error>{errorMessage}</Error>}
            </FieldsContainer>
            <ButtonContainer>
              <CustomButton handle={Submit} title="Continue" />
            </ButtonContainer>
            {!location.state.forgetPassword && (
              <>
                <ResendLink href="#" onClick={handleResendOtp}>
                  Issues with your authentication code? Request a new one
                </ResendLink>
              </>
            )}
            </LeftContaienrContent>
          </LeftContaienr>
        </InnerContainer>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 85vh;
  gap: 1vh;
`;

const InnerContainer = styled.div`
  padding: 100px 100px;
  min-height: 85vh;
  width: 90vw;
  border-radius: 30px;
  background-image: url(${womanDoctor});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: local;
  padding: 7%;
  
  @media screen and (max-width: 662px) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;

const LeftContaienr = styled.div`
  display: flex;
  flex-direction: column;
  width: 30vw;
  min-width: 300px;
    border-radius: 20px;
  gap: 2vh;
  border-radius: 20px;
  background: #ecf3fb;
  

`;
const LeftContaienrBanner = styled.div`
display:flex;
width:auto;
background-color:#304961;
min-height:2vh;
padding:8%;
border-radius: 20px 20px 0 0;
align-items: center;
justify-content: center;
  box-shadow:0px 0px 10px #304961;


`;
const LeftContaienrContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  width: auto;
  gap: 2vh;
  background: #ecf3fb;
  padding:2%;
  border-radius:20px;

  @media screen and (max-width: 662px) {
    gap: 20px;
    padding: 20px 10px;
  }
`;


const Title = styled.p`
  margin-bottom: 20px;
  color: var(--white);
font-family: 'Georgia';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 90%;
  letter-spacing: 1px;
  white-space: wrap;
  text-transform: uppercase;


`;

const Text = styled.p`
width:80%;
  color: var(--darkBlue);
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

const FieldsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const Error = styled.div`
  color: #b20000;
  text-align: left;
  width: 80%;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: italic;
  font-weight: 300;
`;

const ResendLink = styled.a`
  color: var(--darkBlue);
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;

width:80%;

  &:hover {
    opacity: 0.8;
  }

`;

export default RequireLogout(Otp);